import axios from "axios";
import React, { useContext, createContext, useEffect } from "react";
import { MealServices } from "../services/MealServices";
import { OrdersServices } from "../services/OrdersServices";

// ** Hooks Imports
import { useAuth } from "./useAuth";
import { useLanguage } from "./useLanguage";
import { useMeals } from "./useMeals";
import { useOrder } from "./useOrder";

// ** Services Imports
//   import { CartServices } from "../services/CartServices";

const apiFetchPromiseContext = createContext();

export function ProviderApiFetchPromise({ children }) {
  const apiFetchPromise = useProviderApiFetchPromise();
  return (
    <apiFetchPromiseContext.Provider value={apiFetchPromise}>
      {children}
    </apiFetchPromiseContext.Provider>
  );
}

export const useApiFetchPromise = () => {
  return useContext(apiFetchPromiseContext);
};

// Provider hook that creates Cart object and handles state
function useProviderApiFetchPromise() {
  // ** Hooks
  const {language} = useLanguage()
  const { userSecure } = useAuth();
  const { setOrder, setOrderStatus } = useOrder();
  const { setMealTypes } = useMeals();

  // ** End Hooks
  useEffect(() => {
    if (userSecure?.access_token?.length > 0) {
      const allInitRequest = [
        OrdersServices.getMyOrders({ token: userSecure?.access_token || ''}),
        OrdersServices.ordersStatus({ token: userSecure?.access_token || ''})
      ];
      axios
        .all(allInitRequest)
        .then(
          axios.spread(({ data: data_order }, { data: data_orders_status }) => {
            console.log("data_orders_status", data_orders_status);
            // ** Order
            setOrder({
              items: [...data_order?.data] || [],
              orderLoading: false,
              nextUrl: data_order?.links?.next
            });
            //
            // ** End Order
            // ** Orders Status
            const itemsOrdersStatus = [];
            for (const key in data_orders_status) {
              if (Object.hasOwnProperty.call(data_orders_status, key)) {
                itemsOrdersStatus.push({
                  keyVal: key,
                  value: data_orders_status[key]
                });
              }
            }
            // const data_orders_status
            setOrderStatus({
              items: [...itemsOrdersStatus],
              loading: false
            });
            //
            // ** End Orders Status
          })
        )
        .catch((errors) => {
          console.log('errors', errors)
        });
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSecure,language]);

  useEffect(() => {
    document.addEventListener("DOMContentLoaded", () => {
      const allInitRequest = [MealServices.getMealTypes()];
      
      axios
        .all(allInitRequest)
        .then(
          axios.spread(({ data: data_meal_types }) => {
            // ** Meal Types
            console.log("----data_meal_types?.data",data_meal_types?.data);
            setMealTypes([...data_meal_types?.data]);
            // ** End Meal Types
          })
        )
        .catch((errors) => {
          console.log('errors', errors)
        });
    })

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
}
